import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environment/environments';

const OWN_PROFILE_PHOTO_URL = (userId: string): string =>
  `${environment.baseUrl}/pahdp-user/v1/users/${encodeURIComponent(userId)}/photo`;

interface OwnProfilePhotoResponse {
  photo: string;
}

@Injectable({ providedIn: 'root' })
export class ProfilePhotoApi {
  private readonly http = inject(HttpClient);

  async getOwnProfilePhoto(userId: string): Promise<string | undefined> {
    try {
      const response = await firstValueFrom(this.http.get<OwnProfilePhotoResponse>(OWN_PROFILE_PHOTO_URL(userId)));
      return response.photo;
    } catch (error) {
      if (error instanceof HttpErrorResponse && error.status === 404) return undefined;
      throw error;
    }
  }
}
